import Close from '@mui/icons-material/Close';
import { Grid, Stack, Typography } from '@mui/material';
import React, { useCallback, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { formatBytes, generateRandomUUID, newUploadFiles } from '../../../../../../libs/HelperContent';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../../../../libs/Context';
import { useDropzone } from 'react-dropzone';
import Loading from '../../../../../../components/Common/Loaders/FullWidthLoader/Loading';

const AddAttachments = (props) =>
{
	const { attachments = [], handleSet } = props;
	const userData = useSelector((state:any) => state.mysession.session);
	const [ loading, setLoading ] = useState(false);
	const { language } = useContext(LanguageContext);
	let FILE_LIMIT = 5 - attachments?.length;

	FILE_LIMIT = FILE_LIMIT < 0 ? 0 : FILE_LIMIT;
	const totalUploadedSize = attachments?.reduce((acc, file) =>
		acc + file.size, 0); // 250 MB
	const MAX_TOTAL_SIZE = 250 * 1024 * 1024 - totalUploadedSize;

	const onDrop = async (fileList) =>
	{
		if (fileList.length > 0)
		{
			if ((fileList?.length + attachments?.length) > 5)
			{
				toast.error(language?.fileUploadLimit, {
					position : toast.POSITION.TOP_RIGHT
				});
			}
			else
			{
				const folderPath = `webinar/${userData?.userId}`;

				setLoading(true);
				let upload:any = await newUploadFiles(fileList, folderPath);

				upload = upload.map((item) => ({ ...item, mediaType: 'document' }));

				if (upload?.length > 0)
				{
					handleSet('attachments', [ ...attachments, ...upload ]);
				}
			}
			setLoading(false);
		}
	};

	const onDropRejected = useCallback((fileRejections) =>
	{
		const errorMessages = fileRejections.map((rejection) =>
		{
			const { errors } = rejection;

			return errors.map((error) =>
			{
				switch (error.code)
				{
					case 'file-too-large':
						return language?.totalAllowedSize;
					case 'too-many-files':
						return language?.fileUploadLimit;
					case 'file-invalid-type':
						return language?.invalidFileType;
					default:
						return language?.fileRejected;
				}
			});
		}).flat();

		toast.error(errorMessages[0], {
			position  : toast.POSITION.TOP_RIGHT,
			autoClose : 2000
		});
	}, []);

	const acceptType = {
		maxFiles : FILE_LIMIT,
		maxSize  : MAX_TOTAL_SIZE,
		accept   : {
			'application/pdf' : [ '.pdf' ]
		},
		onDrop,
		onDropRejected
	};
	const { getRootProps, getInputProps } = useDropzone(acceptType);

	const handleDelete = (index) =>
	{
		const updAttach = [ ...attachments ];

		updAttach.splice(index, 1);
		handleSet('attachments', updAttach);
	};

	return (
		<>
			<Typography my='var(--pixel8)' variant='inherit' py='var(--pixel8)' fontWeight={'var(--font500)'}>
				{language?.addattachments} ({attachments?.length}/5)
			</Typography>
			{loading && <Loading/>}
			<Grid
				xs={12}
				p='var(--pixel8)'
				my='var(--pixel8)'
				style={{ backgroundColor: 'var(--whiteF7)', border: '1px dotted var(--primaryColor)', borderRadius: 'var(--pixel8)', cursor: 'pointer' }}
				textAlign='center'
				// onClick={handleFileClick}
				{...getRootProps()}
			>
				<Typography variant='inherit' color='textSecondary'>
					{/* {language?.selctFiles} */}
					{language?.selectPdfLimit}
				</Typography>
			</Grid>
			<input type='file' {...getInputProps()} multiple style={{ display: 'none' }} />
			<Grid container>
				{attachments.map((file, index) => (
					<Grid container
						key={`file-${file?._id ?? file?.id ?? generateRandomUUID()}`}
						xs={12}
						sm={6}
						p='var(--pixel4)'
					>
						<Grid
							item container
							style={{ backgroundColor: 'var(--whiteF4)', borderRadius: 'var(--pixel4)', padding: 'var(--pixel8)', alignItems: 'center', flexWrap: 'nowrap', width: 'var(--percent100)' }}
						>
							<Grid item>
								<img src='/documents/pdf.png' alt='pdf' style={{ width: 'var(--pixel18)', height: 'var(--pixel20)' }} />
							</Grid>
							<Grid item xs style={{ paddingLeft: 'var(--pixel8)', flexGrow: 1, overflow: 'hidden' }}>
								<Stack direction='row' spacing={1} width='var(--percent100)'>
									<Typography fontSize='var(--pixel14)'
										sx={{ overflow     : 'hidden',
											textOverflow : 'ellipsis',
											whiteSpace   : 'nowrap',
											maxWidth     : 'calc(100% - 100px)' }}
									>{file.name}</Typography>
									<Typography fontSize='var(--pixel14)' color='var(--txtColorBlackL)'>{formatBytes(file?.size)}</Typography>
								</Stack>
							</Grid>
							<Grid item sx={{ alignItems: 'center', display: 'flex' }}>
								<Close onClick={() => handleDelete(index)} style={{ cursor: 'pointer', fontSize: 'var(--pixel18)' }} />
							</Grid>
						</Grid>
					</Grid>
				))}
			</Grid>
		</>
	);
};

export default AddAttachments;